import { render, staticRenderFns } from "./TemplateNone.vue?vue&type=template&id=babb30da&scoped=true"
import script from "./TemplateNone.vue?vue&type=script&lang=js"
export * from "./TemplateNone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babb30da",
  null
  
)

export default component.exports